import { render, staticRenderFns } from "./product-details-barcodes.vue?vue&type=template&id=0ba29381&scoped=true&"
import script from "./product-details-barcodes.vue?vue&type=script&lang=js&"
export * from "./product-details-barcodes.vue?vue&type=script&lang=js&"
import style0 from "./product-details-barcodes.vue?vue&type=style&index=0&id=0ba29381&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba29381",
  null
  
)

export default component.exports